<template>
  <ul>
    <div class="row large-col columns large-centered" id="menu_bar">
        <li id="home_menu" :class="menuItemStyle">
            <router-link to="/home"><span><i class="fa fa-home" aria-hidden="true"></i>&nbsp;&nbsp; Accueil</span></router-link></li>
        <li id="news_menu" :class="menuItemStyle">
            <router-link to="/news"><span><i class="fa fa-microphone" aria-hidden="true"></i>&nbsp;&nbsp; Actualités</span></router-link></li>
        <li v-if="isLogged" id="ranking_menu" :class="menuItemStyle">
            <router-link :to="{ name:'rankingGeneral'}"><span><i class="fa fa-bar-chart" aria-hidden="true"></i>&nbsp;&nbsp; Classement</span></router-link></li>
        <li  v-if="isLogged" id="team_menu" :class="menuItemStyle">
            <router-link :to="{ name:'TeamList'}"><span><i class="fa fa-list" aria-hidden="true"></i>&nbsp;&nbsp; Equipes</span></router-link></li>
        <li  v-if="isLogged" id="match_menu" :class="menuItemStyle">
            <router-link :to="{ name:'matchReportList'}"><span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;&nbsp; Les matchs</span></router-link></li>
        <li v-if="isLogged" id="other_menu" :class="menuItemStyle">
            <router-link :to="{ name:'pageList'}"><span><i class="fa fa-balance-scale" aria-hidden="true"></i>&nbsp; Règlement</span></router-link></li>
        <li v-if="isLogged" id="admin_menu" :class="menuItemStyle">
            <router-link :to="{ name:'bingoedf'}"><span><i class="fa fa-trophy" aria-hidden="true"></i>&nbsp; Tournois</span></router-link></li>
    </div>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'topmenu',
  computed:
  {
    ...mapGetters([
      'isLogged'
    ]),
    menuItemStyle: function () {
      if (this.isLogged && this.$store.getters.currentUser && this.$store.getters.currentUser.is_superuser === false) {
        return 'large-2'
      } else {
        return 'large-1 menu-item'
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
    list-style-type: none;
    margin-bottom: 0rem;
    margin-left: 0rem;
    background-color:rgba(4,54,96,1);
    font-weight: 200;
}

li {
    float: left;
}

li a, .dropbtn {
    display: inline-block;
    color: white;
    text-align: center;
    padding: 0.5rem 1rem;
    text-decoration: none;
    width: 100%;
    font-size: 1rem;
    -webkit-transition: background-color 0.3s; /* Safari */
    transition: background-color 0.3s;
}

li a:hover,
.dropdown:hover
.dropbtn {
    background-color: rgba(50,107,155,1);
    color: #ffffff;
}

li .active {
    background-color: rgba(50,107,155,1);
}
  .menu-item {
    width: 10rem;
  }
</style>



// WEBPACK FOOTER //
// top-menu.vue?787b4a2e